import {
  isMyBiz,
  isMyPartner,
  isPartnerGI,
  isPartnerMMT,
} from "@tm/insurance/utils";

import { GIAnalytics } from "./GIAnalytics";
import { IAnalytics } from "./IAnalytics";
import { MmtAnalytics } from "./MmtAnalytics";

let analytics: IAnalytics | null = null;

export function getAnalytics(): IAnalytics | null {
  if (analytics === null && (isPartnerMMT() || isMyPartner() || isMyBiz())) {
    analytics = new MmtAnalytics();
  } else if (analytics === null && isPartnerGI()) {
    analytics = new GIAnalytics();
  }
  return analytics;
}
